const FEATURED_OVERRIDES_KEY = 'litium-visual-prompt-featured-overrides';

type FeaturedOverrides = Record<string, boolean>;

const readOverrides = (): FeaturedOverrides => {
  try {
    const raw = localStorage.getItem(FEATURED_OVERRIDES_KEY);
    if (!raw) {
      return {};
    }
    const parsed = JSON.parse(raw) as FeaturedOverrides;
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
};

export const getFeaturedOverride = (promptId: string): boolean | undefined => {
  const overrides = readOverrides();
  return overrides[promptId];
};

export const setFeaturedOverride = (
  promptId: string,
  isFeatured: boolean,
): void => {
  const overrides = readOverrides();
  overrides[promptId] = isFeatured;
  localStorage.setItem(FEATURED_OVERRIDES_KEY, JSON.stringify(overrides));
};
